import { Modal } from '@ts/components/Modal';
import { VideoPlayer } from '@ts/components/VideoPlayer';
import { Share } from '@ts/components/Share';

export const init = () => {
    setPlayVideo();
    setShareSite();
}

const setPlayVideo = () => {
    const playVideoButton = document.getElementById('play-video');
    if (!playVideoButton) return;
    playVideoButton.addEventListener('click', (e) => {
        e.preventDefault();
        openShopVideoModal();
    });
}

const openShopVideoModal = () => {
    const shopVideoModal = document.getElementById('shop-video-modal');

    if (!shopVideoModal) return;
    Modal.create(shopVideoModal, {
        modalSize: 'modal-auto',
        headless: true,
        onOpen: () => {
            setShopVideoPlayer();
        }
    });
}

const updateShopVideoPlayer = (playerId, mediaId) => {
   const shopVideo = VideoPlayer.getPlayer(playerId);
   shopVideo.loadVideo(mediaId);
}

const setShopVideoPlayer = () => {
    const mediaId = document.getElementById('video-player')?.dataset.mediaId;

    if (!mediaId) return;
    VideoPlayer.create('#video-player', {
        mediaId: mediaId
    });
}

const setShareSite = () => {
    // share-btn
    const shareBtns = document.querySelectorAll('.shop-profile-details .share-btn');
    shareBtns.forEach((btn) => {
        const webshare = Share.create(btn, {
            url: btn.dataset.shareUrl,
            text: btn.dataset.shareText
        });
    });
}